import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PointAction from '../actions/PointAction'
import DtoPoint from '../dto/DtoPoint'
import AppStore from '../../store/AppStore'
import LoadingPanel from '../../components/loading/LoadingPanel'
import PointDescriptionPanel from './description/PointDescriptionPanel'
import HomeAction from '../../home/actions/HomeAction'
import DtoKeyFigures from '../../sites/dto/DtoKeyFigures'
import TypePointPanel from './pointType/TypePointPanel'
import { PATH_HOME, PATH_RESEARCH } from '../../home/constants/HomeConstants'
import PointMap from './map/PointMap'
import PointKeyFiguresPanel from './keyFigures/PointKeyFiguresPanel'
import { push } from 'react-router-redux'
import DtoType from '../../referential/dto/DtoSiteType'
import { find } from 'lodash'
import PointProximityChart from './proximity/charts/PointProximityChart'
import { getDistanceBetweenCoordsWGS84 } from '../../utils/DistanceUtils'
import DtoStation from '../../sites/dto/DtoStation'
import PointProximityPanel from './proximity/PointProximityPanel'
import NoInformationPanel from './util/NoInformationPanel'
import SourcePanel from './source/SourcePanel'
import HTML5Backend from 'react-dnd-html5-backend'
import { DragDropContext } from 'react-dnd'
import i18n from 'simple-react-i18n'

class PointApp extends Component {
	constructor(props) {
		super(props)
		this.state = {
			height: 50
		}
	}

	componentWillMount() {
		//if (this.props.selectedStations.length) {
		AppStore.dispatch(PointAction.fetchPoint(this.props.params.id))
		AppStore.dispatch(HomeAction.setBackPath(PATH_RESEARCH))
		//} else {
		//	AppStore.dispatch(push(PATH_HOME))
		//		}
	}

	componentWillUnmount() {
		AppStore.dispatch(PointAction.reset())
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.point && nextProps.point.code) {
			const name = nextProps.point.name ? nextProps.point.name : nextProps.point.code
			AppStore.dispatch(HomeAction.setTitle(nextProps.point.code + ' - ' + name))
		} else {
			AppStore.dispatch(HomeAction.setTitle(i18n.point.sheet))
		}
	}

	getTitleLoad = () => {
		if (this.props.point && this.props.point.name && this.props.siteTypes.length) {
			return '100'
		}
		return i18n.point.loading
	}

	setHeight = (height) => {
		this.setState({
			height: height
		})
	}

	getSiteType = () => {
		const siteType = find(this.props.siteTypes, (o) => {
			return o.id == this.props.params.typeId
		})
		if (siteType) {
			return siteType
		}
		AppStore.dispatch(push(PATH_HOME))
		return null
	}

	getTypePoint = (siteType, show = false) => {
		if (show) {
			return (
				<div className='row no-margin'>
					<div className='col s12'>
						<TypePointPanel parameter={ siteType.parameter } />
					</div>
				</div>
			)
		}
		return null
	}

	calculateDistance = (point) => {
		return getDistanceBetweenCoordsWGS84([this.props.point.yCoordinate, this.props.point.xCoordinate], [point.yCoordinate, point.xCoordinate])
	}

	getProximityPoint = () => {
		if (this.props.selectedStations.length) {
			return this.props.selectedStations.map((o) => {
				return {
					distance: Number(this.calculateDistance(o)),
					station: o
				}
			})
		}
		return []
	}

	getProximityChart = (proximityPoint, siteType) => {
		if (proximityPoint.length) {
			return (
				<PointProximityChart proximityStation={ proximityPoint } siteType={ siteType } />
			)
		}
		return (<NoInformationPanel />)
	}

	getProximityPanel = (proximityPoint, siteType) => {
		if (proximityPoint.length) {
			return (
				<PointProximityPanel proximityStation={ proximityPoint } siteType={ siteType } />
			)
		}
		return (<NoInformationPanel />)
	}

	getPanel = () => {
		const loadingValue = this.getTitleLoad()
		if (loadingValue === '100') {
			const siteType = this.getSiteType()
			const proximityPoint = this.getProximityPoint()
			return (
				<div className='row no-margin'>
					<div className='col s8'>
						<div className='row no-margin'>
							<div className='col s12 no-padding'>
								<PointDescriptionPanel id={ 'descriptionPanel' } setHeight={ this.setHeight } />
							</div>
						</div>
						<div className='row no-margin'>
							<div className='col s12 no-padding'>
								<PointKeyFiguresPanel siteType={ siteType } />
							</div>
						</div>
						<div className='row no-margin'>
							<div className='col s12 no-padding'>
                                { this.getProximityChart(proximityPoint, siteType) }
							</div>
						</div>
						{ this.getTypePoint(siteType) }
					</div>
					<div className='col s4'>
						<div className='row no-margin'>
							<div className='col s12 no-padding'>
								<SourcePanel />
							</div>
							<div className='col s12 no-padding'>
								<PointMap height={ this.state.height } />
							</div>
							<div className='col s12 no-padding'>
								{ this.getProximityPanel(proximityPoint, siteType) }
							</div>
						</div>
					</div>
				</div>
			)
		}
		return (<LoadingPanel title={ loadingValue } />)
	}

	render() {
		return (
			<div className={ 'row' }>
				<div className='col s12'>
					{ this.getPanel() }
				</div>
			</div>
		)
	}

	componentDidMount() {
		if (document.getElementById('descriptionPanel')) {
			this.setState({
				height: document.getElementById('descriptionPanel').clientHeight
			})
		}
	}
}

PointApp.propTypes = {
	params: PropTypes.shape({
		id: PropTypes.number,
		typeId: PropTypes.number
	}),
	point: PropTypes.objectOf(DtoPoint),
	pointKeyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures)),
	siteTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoType)),
	selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation))
}


const mapStateToProps = store => {
	return {
		point: store.PointReducer.point,
		siteTypes: store.ReferentialReducer.siteTypes,
		pointKeyFigures: store.PointReducer.pointKeyFigures,
		selectedStations: store.SitesReducer.selectedStations
	}
}

const dragContext = DragDropContext(HTML5Backend)(PointApp)

export default connect(mapStateToProps)(dragContext)



// WEBPACK FOOTER //
// ./src/point/components/PointApp.js